/**
 * //////////////////////////////////
 * フォームテンプレー
 * /////////////////////////////////
 *
 * コンポーネントのフォームテンプレはここに書いています。
 * ＨＴＭＬフォームで未入力状態でフォーム送信を実行すればフォームの入力キーが無くなってしまうので、nullフィールドがあっても、
 * 必ずフォームテンプレを送信するようにここにファイルが必要です。
 */

/***
 * 新規住所追加・住所編集フォーム
 * @type {{postal_code, state, city, address}}
 */
const createEditForm = {
    postal_code: null,
    state: null,
    city: null,
    address: null
}

const forms = {
    createEditForm
}

export default forms;
